import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
  changes: [],
  editRowKey: null,
  gridIsLoading: false,
};

const slice = createSlice({
  name: 'assumptionGridSlice',
  initialState,
  reducers: {
    resetChanges: (state, action) => {
      state.changes = [];
      state.editRowKey = null;
    },
    setChanges: (state, action) => {
      state.changes = action.payload;
    },
    setEditRowKey: (state, action) => {
      state.editRowKey = action.payload;
    },
    setGridIsLoading: (state, action) => {
      state.gridIsLoading = action.payload;
    },
  },
});

export default slice.reducer;

export const assumptionGridActions = slice.actions;
